.screen {
	min-height: 100%;
	padding: var(--space-5);
	padding-bottom: calc(var(--space-5) + var(--tab-bar-h));
	max-width: var(--screen-max);
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: var(--space-6);
}

.back {
	background: none;
	border: none;
	padding: 0;
	color: var(--ink-muted);
	cursor: pointer;
	display: inline-flex;
}

.back:hover {
	color: var(--ink);
}

.title {
	margin: 0;
	font-size: 1.05rem;
	font-weight: 600;
}

.section {
	display: flex;
	flex-direction: column;
	gap: var(--space-3);
}

.sectionTitle {
	margin: 0;
	font-size: 0.8rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.06em;
}

.subTitle {
	margin: var(--space-2) 0 0 0;
	font-size: 0.8rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.06em;
}

/* Sits in SettingsRow's value slot, so it drops the boxed input look and
   keeps the row's own height. */
.inlineInput {
	width: 100%;
	padding: 0;
	border: none;
	border-bottom: 1px solid var(--accent-sage);
	border-radius: 0;
	background: none;
	font: inherit;
	color: var(--ink);
}

.inlineInput:focus-visible {
	outline: none;
}

.error {
	color: color-mix(in oklab, var(--accent-rose) 70%, black);
}

.muted {
	margin: 0;
	color: var(--ink-muted);
	font-size: 0.9rem;
}

.members {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: var(--space-1);
}

.member {
	display: flex;
	align-items: center;
	gap: var(--space-3);
	padding: var(--space-2) var(--space-3);
	border-radius: var(--radius-sm);
}

.avatar {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	flex: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 0.8125rem;
	font-weight: 600;
}

.memberName {
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.you {
	flex: none;
	font-size: 0.7rem;
	font-weight: 600;
	color: var(--ink-muted);
	background: var(--surface-input);
	border: 1px solid var(--border);
	border-radius: 999px;
	padding: 2px var(--space-2);
}

.signOut {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: var(--space-2);
	background: none;
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	padding: var(--space-3) var(--space-4);
	font: inherit;
	font-size: 0.9rem;
	font-weight: 600;
	color: var(--ink-muted);
	cursor: pointer;
}

.signOut:hover:not(:disabled) {
	color: var(--ink);
	background: var(--surface-card);
}

.signOut:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

/* Same shape as .signOut, in the rose that every other destructive control
   uses — sitting under Sign out so the two ways of leaving are together. */
.deleteAccount {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: var(--space-2);
	background: none;
	border: 1px solid color-mix(in srgb, var(--accent-rose) 40%, transparent);
	border-radius: var(--radius-md);
	padding: var(--space-3) var(--space-4);
	font: inherit;
	font-size: 0.9rem;
	font-weight: 600;
	color: var(--accent-rose);
	cursor: pointer;
}

.deleteAccount:hover {
	background: color-mix(in srgb, var(--accent-rose) 8%, transparent);
}

.deleteAccount:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
